import ApolloClient from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { ApolloLink, concat } from 'apollo-link';
import { InMemoryCache } from 'apollo-cache-inmemory';
import fetch from 'node-fetch';
import { GRAPH_URL } from './components/network/api';
import { hlog } from './components/common/util';
import { CONFIG } from './config';

const httpLink = new HttpLink({ uri: GRAPH_URL, fetch });

const logger = new ApolloLink((operation, forward) => {
  hlog('--------start---------');
  hlog(`Graphql Operation ${operation.operationName}`);
  hlog(operation);
  return forward(operation).map((result) => {
    hlog(`Graphql Result for Operation ${operation.operationName}`);
    hlog(result);
    hlog('--------end---------');
    return result;
  });
});

const client = new ApolloClient({
  link: CONFIG.DEV ? concat(logger, httpLink) : httpLink,
  cache: new InMemoryCache(),
  fetch
});

export default client;



// WEBPACK FOOTER //
// ./src/hhApolloClient.js